import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { applyBrand } from '../../actions/app/brand.actions'
import brandSelector from '../../selectors/brandSelector'
import audiFavicon from '../../../assets/media/favicons/audi.ico'
import vwFavicon from '../../../assets/media/favicons/vw.ico'
import cupraFavicon from '../../../assets/media/favicons/cupra.ico'
import seatFavicon from '../../../assets/media/favicons/seat.ico'
import skodaFavicon from '../../../assets/media/favicons/skoda.ico'
import skodaItFavicon from '../../../assets/media/favicons/skoda_IT.ico'
import manFavicon from '../../../assets/media/favicons/man.ico'
import countrySelector from "../../selectors/i18n/countrySelector"
import { setBrand } from '../../../i18n/currentBrand'

const brandMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(applyBrand, action)) {
        const brand = brandSelector(store.getState())
        const country = countrySelector(store.getState())

        setBrand(brand)

        document.body.classList.add(brand)
        document.body.classList.add("country_" + country)

        const faviconMap = {
            audi: audiFavicon,
            vw: vwFavicon,
            vwn: vwFavicon,
            seat: seatFavicon,
            skoda: skodaFavicon,
            skoda_IT: skodaItFavicon,
            man: manFavicon,
            cupra: cupraFavicon,
        }

        const brandWithOrWithoutCountry = (faviconMap[`${brand}_${country}`] !== undefined)
            ? `${brand}_${country}`
            : brand

        const faviconElement: HTMLLinkElement = document.head.querySelector('[rel="icon"]')

        faviconElement.href = faviconMap[brandWithOrWithoutCountry]
    }
}

export default brandMiddleware
